export default function initScrollPage() {
    const scrollBtn = document.querySelector('.js-scroll-to-page');

    if (!scrollBtn) return;

    scrollBtn.addEventListener('click', () => {
        const banner = scrollBtn.closest('.l-hero-banner');
        
        if (banner) {
            const scrollTarget = banner.offsetHeight + banner.offsetTop;

            window.scrollTo({
                top: scrollTarget,
                behavior: 'smooth'
            });
        }
    });
}